import Vue from 'vue'
import App from './App.vue'

import './plugins/mixins'
import './plugins/components'
import './plugins/session'
import './plugins/http'
import './plugins/helpers'

import './assets/material_icons.css'
import './assets/material_outline.css'
import './assets/product_sans.css'
import './assets/application.scss'
import './assets/icon_assinatura.css'

import './directives/input-filter'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
